<template lang="pug">
  div.container-fluid
    div.row.justify-content-center
      div.col-12.col-md-8.col-xl-7(v-for="svg in svglist", :key="svg", style="position:relative; font-size:10vw;")
        object.print(type="image/svg+xml", :data="svg", style="width: 100%")
        span.watermark1 GokakuEssayLibrary
        span.watermark2 {{ $store.state.auth.email }}
</template>


<script>

export default {
  name: 'Svg',
  components: {
  },
  head: {
    title: {
      inner: 'Essay'
    },
    meta: [
      { name:"robots", content:"none"},
      { name:"description", content:""}
    ]
  },
  data (){
      return {
        svglist:[]
      }
  },
  mounted (){
    this.get();
  },
  methods:{
    get (){
      this.$axios.get("/api/svg?item_id="+this.$route.query.item_id)
      .then((response) => {
        this.svglist = response.data;
      });
    }
  },
}
</script>



<style scoped>
@media print{
  .print {
    display: none;
  }
}


.watermark1 {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 80%;
  font-weight: bold;
  color: rgba(180, 0, 0, 0.2);
}

.watermark2 {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 50%;
  font-weight: bold;
  color: rgba(180,0,0,0.2);
}

@media(min-width: 768px){
  .watermark1 {
    font-size: 55%;
  }
  .watermark2 {
    font-size: 40%;
  }
}
@media(min-width: 1200px){
  .watermark1 {
    font-size: 40%;
  }
  .watermark2 {
    font-size: 30%;
  }
}
</style>